<template>
    <product-detail-layout id="product-detail-page">
        <div class="row">
            <section id="go-back-section" class="mb-3">
                <div class="col-12">
                    <font-awesome-icon :icon="['fas', 'chevron-left']" />
                    <span class="text-link" @click="goBack()">
                        {{ $t('pds.backToCatalog') }}
                    </span>
                </div>
            </section>
        </div>
        <div class="row">
            <div class="col-12">
                <section id="product-header-section" itemscope itemtype ="https://schema.org/Product">
                    <product-header-box
                        :entry="entry"
                        :is-loading="isLoading"
                        :is-active="isActive"
                    ></product-header-box>
                </section>
            </div>
        </div>

        <div class="mt-5 row">
            <div class="col-12 col-md-8">
                <section id="product-body-section">
                    <product-content-box
                        :entry="entry"
                        :is-loading="isLoading"
                    ></product-content-box>
                </section>
            </div>
            <div class="col-12 col-md-4">
                <section
                    v-if="isActive && !(this.$root.whitelabel.setting('leads_active') || this.$root.whitelabel.setting('leads_url')) && !multilocations"
                    id="delivery-calculator-section">
                    <pickup-and-return-box
                        :entry="entry"
                    ></pickup-and-return-box>
                </section>

                <multilocations 
                    v-if="multilocations" 
                    :locations="this.entry.multilocations.locations"
                ></multilocations>

                <section id="partner-contact-section">
                    <partner-contact-box
                        v-if="isActive"
                        class="mt-4"
                        :entry="entry"
                        :is-loading="isLoading"
                    ></partner-contact-box>
                </section>

                <ad name="ad_below_contact" class="mt-3"></ad>
            </div>
        </div>
    </product-detail-layout>
</template>

<script>
import ProductDetailLayout from '../../layouts/ProductDetailLayout.vue'
import Ad from '../../components/atoms/Ad.vue'
import ProductHeaderBox from '../../components/organisms/ProductHeaderBox.vue'
import ProductContentBox from "../../components/organisms/ProductContentBox.vue";
import DeliveryCalculatorBox from "../../components/molecules/DeliveryCalculatorBox.vue";
import PickupAndReturnBox from '../../components/molecules/PickupAndReturnBox.vue';
import PartnerContactBox from "../../components/molecules/PartnerContactBox.vue";
import Multilocations from "../../components/molecules/Multilocations.vue";
import { BLink } from "bootstrap-vue"

export default {
    components: {
        Ad,
        PartnerContactBox,
        ProductDetailLayout,
        DeliveryCalculatorBox,
        PickupAndReturnBox,
        ProductHeaderBox,
        ProductContentBox,
        Multilocations,
        BLink
    },
    data(){
        return {
            entry: null,
            isLoading: true,
            metaTitle: '',
            previousPage: null,
            previousUrl: ''
        }
    },
    methods: {
        getEntryData(){
            this.isLoading = true

            this.$axios(this.builtApiUrl)
                .then(r => {
                    this.isLoading = false
                    this.entry = r.data.data
                    this.metaTitle = this.entry.title
                    this.$emit('updateHead')
                })
        },
        goBack(){
            let path = ''
            if(this.$route.query.path) {
                path = JSON.parse(decodeURI(this.$route.query.path))
            }

            this.$goTo('catalog', null, path)
        }
    },
    computed: {
        builtApiUrl() {
            return `/api/v1/catalog/vehicle/${this.$route.params.productUuid}`
        },
        isActive() {
            if(this.entry !== null) {
                if(this.$route.query.private_token !== undefined) {
                    return this.entry.private_token === this.$route.query.private_token
                } else {
                    return this.entry.status === 'VEHICLE_ACTIVE'
                }
            } else {
                return false
            }
        },
        multilocations() {
            if (this.entry) {
                return this.entry.multilocations.active
            }

            return false
        }
    },
    mounted() {
        this.getEntryData()
    },
    head: {
        title: function () {
            return {
                inner: this.$root.whitelabel.state.settings.meta_title,
                complement: this.metaTitle
            }
        },
        meta: function () {
            return [
                { name: 'description', content: this.$t('meta.pdp.description') }
            ]
        }
    }
}
</script>
